import { BaseService } from '@/services/BaseService';

class DashboardUserGroupsContentsUserRatingsService extends BaseService {
  getUserRatings(contentId, page = 1, size = 10) {
    return this.get(`${contentId}/user-ratings`, { params: { page, size } });
  }
  getUserRatingsSummary(contentId) {
    return this.get(`${contentId}/user-ratings/summary`);
  }
  putUserRatings(contentId, ratingId, data) {
    return this.put(`${contentId}/user-ratings/${ratingId}`, data);
  }
  postUserRatingsAnswer(contentId, ratingId, data) {
    return this.post(`${contentId}/user-ratings/${ratingId}/answer`, data);
  }
  putUserRatingsAnswer(contentId, ratingId, data) {
    return this.put(`${contentId}/user-ratings/${ratingId}/answer`, data);
  }
  deleteUserRatingsAnswer(contentId, ratingId) {
    return this.delete(`${contentId}/user-ratings/${ratingId}/answer`);
  }
}

export default new DashboardUserGroupsContentsUserRatingsService('/dashboard/user-groups/contents');
